export const INPUT_CONTROL_METHODS = [
  ['android_tv_remote_v2', 'ATV Remote'],
  ['adb_remote', 'ADB Remote'],
  ['suitestream_remote', 'Suitestream Remote'],
  ['lg_webos_remote', 'LG webOS'],
];
export const DEFAULT_INPUT_CONTROL_METHODS = INPUT_CONTROL_METHODS.map(([method]) => method).filter((method) => method !== 'lg_webos_remote');

export const inputControlMethodLabel = (method) => INPUT_CONTROL_METHODS.find(([value]) => value === method)?.[1] || method;

export function inputTrainingActionBody(action, controlMethods, inputSelectorMethod, wireless = false) {
  if (!wireless && controlMethods) return { action, inputControlMethods: controlMethods, inputSelectorMethod, repeat: 1, intervalMs: 35 };
  return {
    action: action === 'settings' ? 'KEYCODE_SETTINGS' : action,
    ...(wireless ? { controlMethod: 'android_tv_remote_v2' } : {}),
    repeat: 1,
    intervalMs: 35,
    bypassTrainedAutomation: action === 'input' && inputSelectorMethod === 'android_tv_remote',
  };
}

export function inputDeliverySummary(data) {
  return data?.controlMethod
    ? ` using ${inputControlMethodLabel(data.controlMethod)}${data.inputControlAttempts?.some((entry) => entry.status === 'failed') ? ' (fallback)' : ''}` : '';
}

export function inputFailureSummary(error) {
  const attempts = error?.response?.data?.inputControlAttempts;
  return attempts?.length
    ? ` Methods tried: ${attempts.map((entry) => `${inputControlMethodLabel(entry.controlMethod)} (${entry.status})`).join(' → ')}.` : '';
}
